export * from './survey.component';
